export * from './survey.component';
